export default __webpack_public_path__ + "static/media/material-symbols_hourglass-outline.f660d612.svg";